import { takeLatest, put, call, all } from 'redux-saga/effects';
import { createSession } from 'yoda-interfaces/lib/Account/AccountApi';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import * as checkoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import FactorySaga from 'yoda-site-components/lib/sagas/FactorySaga';
import { ANALYTICS_ACTIONS_CREATE_ACCOUNT } from 'yoda-checkout-components/lib/common/Constants';
import * as CreateSessionPostOrderActionTypes from '../actionTypes/CreateSessionPostOrderActionTypes';

function* createSessionPostOrderSaga(action) {
    try {
        const createSessionPostOrderData = yield call(FactorySaga, createSession, action.payload);
        if (createSessionPostOrderData.status === 201) {
            createSessionPostOrderData.userState = '1';
            TokenProvider.storeTokens(createSessionPostOrderData, 'header');
        }
        yield all([
            put({
                type: CreateSessionPostOrderActionTypes.CREATE_SESSION_POST_REQUEST_SUCCESS,
                createSessionPostOrderData,
            }),
            put(
                checkoutAnalyticsAction.clickEventAnalyticsAction(ANALYTICS_ACTIONS_CREATE_ACCOUNT)
            ),
        ]);
        // Commenting below code as endless loop of session and account call was happening
        /* const getAccountCallForVisitorId = yield call(FactorySaga, AccountApi.getAccount, action);
        if (getAccountCallForVisitorId.isSuccess) {
            if (getAccountCallForVisitorId.response.data.customerVid) {
                LocalStorage.setData('DP_VISITOR_ID', getAccountCallForVisitorId.response.data.customerVid);
            } else {
                console.info('***** DA => visitor id - was not received from API *****');
            }
            yield [
                put(checkoutAnalyticsAction.clickEventAnalyticsAction(ANALYTICS.ACTIONS.CREATE_ACCOUNT)),
            ];
        } */
    } catch (createSessionPostOrderError) {
        yield put({
            type: CreateSessionPostOrderActionTypes.CREATE_SESSION_POST_REQUEST_ERROR,
            createSessionPostOrderError,
        });
    }
}

const watchCreateSessionPostOrder = function* watchCreateSessionPostOrder() {
    yield takeLatest(
        CreateSessionPostOrderActionTypes.CREATE_SESSION_POST_REQUEST,
        createSessionPostOrderSaga
    );
};
watchCreateSessionPostOrder.sagaName = 'watchCreateSessionPostOrder';

export default watchCreateSessionPostOrder;
